import React from "react";

const ToggleOption = ({
    active,
    label,
    value,
    onChange,
}) => {
    return (
        <div
            onClick={() => onChange(value)}
            style={{
                padding: "7px 20px",
                borderRadius: "17px",
                cursor: "pointer",
                fontSize: "0.9rem",
                fontWeight: "600",
                transition: "all 0.2s ease",
                backgroundColor: active
                    ? "#4b51b9"
                    : "transparent",
                color: active
                    ? "white"
                    : "#666666",
            }}
        >
            {label}
        </div>
    );
};

const DeviceTypeToggle = ({
    value,
    onChange,
    leftLabel,
    rightLabel,
}) => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "1rem",
                marginBottom: "1rem",
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "3px",
                    borderRadius: "20px",
                    backgroundColor: "#e9ecef",
                    border: "1px solid #dee2e6",
                    width: "fit-content",
                }}
            >
                <ToggleOption
                    active={!value}
                    value={false}
                    label={leftLabel}
                    onChange={onChange}
                />

                <ToggleOption
                    active={value}
                    value={true}
                    label={rightLabel}
                    onChange={onChange}
                />
            </div>
        </div>
    );
};

export default DeviceTypeToggle;